import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=7ffc10cd&scoped=true&"
import script from "./RequestList.vue?vue&type=script&lang=js&"
export * from "./RequestList.vue?vue&type=script&lang=js&"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=7ffc10cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc10cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VCol,VRow,VTab,VTabItem,VTabs,VTabsItems})
